import React, { Component } from 'react'
import { connect } from 'react-redux'
import KUSuperAppOAuthCallback from '../../../components/authentication/oauth/KUSuperAppOAuthCallback'

class KUSuperAppOAuthCallbackPage extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    console.log('render..')
    return (<KUSuperAppOAuthCallback />)
  }
}

export default connect(
  store => ({
    user: store.authen != null && store.authen.user != null ? store.authen.user : null,
    messages: store.theme.messages,
    locale: store.theme.locale,
  }),
  {},
)(KUSuperAppOAuthCallbackPage)
